import { inputRules, InputRule } from "prosemirror-inputrules";
import { Extension } from "../../core/extension";
import { toggleMark } from "../../commands/commands";
import { codeMarkSpec } from "./schema";
export class CodeExtension extends Extension {
    addMarks(marks) {
        return marks.append(codeMarkSpec());
    }
    addPlugins(_, plugins) {
        return plugins.concat([
            inputRules({
                rules: [
                    new InputRule(/`([^`]+)`$/, (state, match, start, end) => {
                        const { schema, tr } = state;
                        return tr.replaceRangeWith(start, end, schema.text(match[1], [schema.marks.code.create()]));
                    }),
                ],
            }),
        ]);
    }
    addCommands(schema) {
        return {
            toggleCodeMark: toggleMark(schema.marks.code),
        };
    }
}
